var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import uuid from 'uuid';
import { apiCreateProffitSearchSlide, apiCreateProffitSearchSlideUploadGroup, } from '@/actions/ProffitSearchAction';
import { apiGetOneProffitSearchInformationTop, hideProffitSearchInformationTopModalProgress, setProffitSearchInformationTopModalUploadGroupId, showProffitSearchInformationTopModalProgress, updateProffitSearchInformationTopUploadItemItems, updateRemoveProffitSearchInformationTopUploadItemItems, } from '@/actions/ProffitSearchInformationTopAction';
import { UPLOAD_PROGRESS_PROFFIT_SEARCH_SLIDE } from '@/define/consts/upload';
import { notifyError, wrapDispatch } from '@/helpers/action';
import { getTemporaryId, uploadSecureFile } from '@/helpers/files';
import { promiseMap } from '@/utils/libs/p-map/promise';
const upload = (option) => __awaiter(void 0, void 0, void 0, function* () {
    const { afterCallback, dispatch, slides, unmountRef } = option;
    const modalId = uuid();
    const addItems = slides.map(() => ({ itemId: uuid(), modalId }));
    // 進捗モーダルの表示
    dispatch(showProffitSearchInformationTopModalProgress(modalId, addItems));
    // アップロードグループの作成
    const { payload: { id: slideUploadGroupId }, } = yield wrapDispatch(dispatch, apiCreateProffitSearchSlideUploadGroup({
        filesCount: slides.length,
    }));
    // 現在処理中のグループIDの設定
    dispatch(setProffitSearchInformationTopModalUploadGroupId(slideUploadGroupId));
    // 並列実行でアップロード処理
    const apiPromise = (() => __awaiter(void 0, void 0, void 0, function* () {
        // secureなfile アップロード
        const uploadSecureFileMapper = (slide, index) => __awaiter(void 0, void 0, void 0, function* () {
            const meta = {
                apiId: uuid(),
                key: UPLOAD_PROGRESS_PROFFIT_SEARCH_SLIDE,
            };
            return uploadSecureFile(dispatch, unmountRef, slide.file, meta, (progress) => {
                dispatch(updateProffitSearchInformationTopUploadItemItems([
                    Object.assign(Object.assign({}, addItems[index]), { progress: Math.floor(progress * 0.9) }),
                ]));
            });
        });
        // secureなfile アップロード処理実行 + 結果取得
        const secureFileIdList = yield promiseMap(slides, uploadSecureFileMapper, { concurrency: 3 });
        // ID取得エラー時の処理
        const getTemporaryIdErrorCallback = (errorText) => {
            notifyError(errorText);
            // アップロード中のアイテムの削除
            dispatch(updateRemoveProffitSearchInformationTopUploadItemItems(addItems));
            // 進捗モーダルの非表示
            dispatch(hideProffitSearchInformationTopModalProgress(modalId, false));
        };
        // ID 取得実行
        for (let i = 0; i < secureFileIdList.length; i += 1) {
            const fileId = secureFileIdList[i];
            // ID 取得
            // eslint-disable-next-line no-await-in-loop
            const temporaryId = yield getTemporaryId(dispatch, unmountRef, fileId, getTemporaryIdErrorCallback);
            // ID が正常な値じゃない場合 処理終了
            if (!temporaryId) {
                return;
            }
        }
        // 進捗を100に変更する
        dispatch(updateProffitSearchInformationTopUploadItemItems(addItems.map((addItem) => (Object.assign(Object.assign({}, addItem), { progress: 100 })))));
        // スライド生成指示の実行
        const slideUpload = (slide, index) => __awaiter(void 0, void 0, void 0, function* () {
            const fileId = secureFileIdList[index];
            const { payload: slidePayload } = yield wrapDispatch(dispatch, apiCreateProffitSearchSlide({
                blockDownload: !!slide.blockDownload,
                blockShare: !!slide.blockShare,
                fileId,
                seq: index + 1,
                shareEmail: (slide.shareEmail || []).map((v) => v.email),
                slideUploadGroupId,
            }));
            // 既存のアップロード中のデータにslideIdを付与
            dispatch(updateProffitSearchInformationTopUploadItemItems([
                Object.assign(Object.assign({}, addItems[index]), { slideId: slidePayload.id }),
            ]));
            // 更新後のデータを反映するためにデータを引き直す
            yield wrapDispatch(dispatch, apiGetOneProffitSearchInformationTop());
        });
        yield promiseMap(slides, slideUpload, { concurrency: 3 });
    }))();
    if (afterCallback) {
        afterCallback();
    }
    yield apiPromise;
});
export const useSlideSearchSlideUpload = {
    upload,
};
